import React, { useContext, useEffect, useMemo, useState } from "react";
import { basicColumns } from "./column";
import { ActionIcon } from "rizzui/action-icon";
import { AuthContext } from "../../context/authContext";
import axios from "axios";
import { baseUrl } from "../account/login";
import MyLoader from "../../component/loader";
import BlankPage from "./blank";
import UploadIcon from "../../assets/upload";
import { useModal } from "../../hooks/useModal";
import ImportMultipleFiles from "../../component/cards/importMultipleFile";
import { useNavigate } from "react-router";
import DataTable from "../../component/table";
import useFetchData from "../../hooks/useFetchData";
import { Text } from "rizzui/typography";

export const orderData = [
  {
    id: "3413",
    nameGiven: "EmployeeRecords_2023.csv",
    fileName: "file_1.txt",
    fileSize: "234kb",
    fileFormat: "PDF",
    createdAt: "03 Jan, 25 | 10:30AM",
  },
  {
    id: "3413",
    nameGiven: "EmployeeRecords_2023.csv",
    fileName: "file_1.txt",
    fileSize: "234kb",
    fileFormat: "PDF",
    createdAt: "03 Jan, 25 | 10:30AM",
  },
  {
    id: "3413",
    nameGiven: "EmployeeRecords_2023.csv",
    fileName: "file_1.txt",
    fileSize: "234kb",
    fileFormat: "PDF",
    createdAt: "03 Jan, 25 | 10:30AM",
  },
  {
    id: "3413",
    nameGiven: "EmployeeRecords_2023.csv",
    fileName: "file_1.txt",
    fileSize: "234kb",
    fileFormat: "PDF",
    createdAt: "03 Jan, 25 | 10:30AM",
  },
  {
    id: "3413",
    nameGiven: "EmployeeRecords_2023.csv",
    fileName: "file_1.txt",
    fileSize: "234kb",
    fileFormat: "PDF",
    createdAt: "03 Jan, 25 | 10:30AM",
  },
  {
    id: "3413",
    nameGiven: "EmployeeRecords_2023.csv",
    fileName: "file_1.txt",
    fileSize: "234kb",
    fileFormat: "PDF",
    createdAt: "03 Jan, 25 | 10:30AM",
  },
  {
    id: "3413",
    nameGiven: "EmployeeRecords_2023.csv",
    fileName: "file_1.txt",
    fileSize: "234kb",
    fileFormat: "PDF",
    createdAt: "03 Jan, 25 | 10:30AM",
  },
  {
    id: "3413",
    nameGiven: "EmployeeRecords_2023.csv",
    fileName: "file_1.txt",
    fileSize: "234kb",
    fileFormat: "PDF",
    createdAt: "03 Jan, 25 | 10:30AM",
  },
  {
    id: "3413",
    nameGiven: "EmployeeRecords_2023.csv",
    fileName: "file_1.txt",
    fileSize: "234kb",
    fileFormat: "PDF",
    createdAt: "03 Jan, 25 | 10:30AM",
  },
  {
    id: "3413",
    nameGiven: "EmployeeRecords_2023.csv",
    fileName: "file_1.txt",
    fileSize: "234kb",
    fileFormat: "PDF",
    createdAt: "03 Jan, 25 | 10:30AM",
  },
];

export default function KnowledgeBase() {
  useEffect(() => {
    document.title = "Knowledge base";
  }, []);

  const navigate = useNavigate();

  const { openModal } = useModal();
  const [page, setPage] = useState(1);
  const { token } = useContext(AuthContext);
  const AuthStr = "Bearer ".concat(token);

  const downloadKnowledgebase = async (id) => {
    try {
      const response = await axios.post(
        `${baseUrl}/knowledgebase/download/${id}`,
        {},
        {
          headers: { Authorization: AuthStr },
        }
      );
      const data = response.data?.data;
      return data?.download_url ?? "#";
    } catch (e) {
      console.log(e);
      return e;
    }
  };
  const { isLoading, error, data, refetch, loading } = useFetchData({
    dataType: "knowledgebase",
    page: page,
  });
  const knowledegebase = data?.data?.map((file) => {
    const id = file._id;
    const nameGiven = file.document_name;
    const fileName = file.document_metadata?.document_name;
    const documentUrl = file.document_metadata?.document_url;
    const createdAt = file.createdAt;
    return { id, nameGiven, fileName, createdAt, documentUrl };
  });

  const download = async (id) => {
    const url = await downloadKnowledgebase(id);
    if (url) window.open(url, "_blank");
  };

  const memoizedData = useMemo(() => knowledegebase || [], [knowledegebase]);

  if (loading) return <MyLoader />;
  else
    return data?.data?.length > 0 ? (
      <div className="w-full">
        <div className="flex justify-end mb-[22px]">
          <ActionIcon
            variant="text"
            className="h-[34px] w-[108px] rounded-[4px] border-[.5px] border-muted py-[10px] px-[16px] gap-[4px] bg-btn hover:text-background text-background"
            onClick={() =>
              openModal({
                view: (
                  <ImportMultipleFiles
                    page="knowledgebase"
                    setUploaded={refetch}
                  />
                ),
              })
            }
          >
            <Text className="font-[400] font-gilroyMedium text-[12px] leading-[14.56px]">
              Upload file
            </Text>
          </ActionIcon>
        </div>
        <DataTable
          data={memoizedData}
          isLoading={isLoading}
          error={error}
          columns={basicColumns}
          setPage={setPage}
          pageSize={data?.metadata?.pagination?.totalPages}
          meta={(row) => {
            if (row) download(row.original.id);
          }}
          defaultSort={{ id: "createdAt", desc: true }}
        />
        {/*         <ActionIcon
          className={`float-right rounded-full ${
            data?.metadata?.pagination?.totalPages > 1
              ? "mt-[-40px]"
              : "mt-[10px]"
          } !bg-btn text-background size-[54px]`}
          onClick={() =>
            openModal({
              view: (
                <ImportMultipleFiles
                  page="knowledgebase"
                  setUploaded={refetch}
                />
              ),
            })
          }
        >
          <UploadIcon />
        </ActionIcon> */}
      </div>
    ) : (
      <BlankPage />
    );
}
